export const NAVIGATE_FORWARD = 'NAVIGATE_FORWARD'
export const NAVIGATE_BACKWARD = 'NAVIGATE_BACKWARD'
export const UPDATE_USER_SETUP_VALUE = 'UPDATE_USER_SETUP_VALUE'
export const SET_STEP_LOADING = 'SET_STEP_LOADING'
export const SET_CARD_DATA = 'SET_CARD_DATA'
